module.exports = __webpack_public_path__ + "static/img/12areaA_09.b3f39d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_09.png
// module id = 799
// module chunks = 1